import { createSlice } from "@reduxjs/toolkit";

const initialRewardsCategoriesState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: [],
  exportData: [],
  uploadimage: [], 
  imageField: [], 
  newRewardsCategory: [], 
  editRewardsCategory: [], 
  deletedRewardsCategory: [],
  companyDropdownList: [],
  countryList: []
};

export const callTypes = {
  list: "list",
  action: "action"
};

export const RewardsCategoriesSlice = createSlice({

  name: "rewardsCategories",
  initialState: initialRewardsCategoriesState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    clearfetchStaffUsers: (state, action) => {
      state.listLoading = false;
      state.error = null;
      state.entities = [];
      state.totalCount = 0;
    },
    emptyList: (state, action) => {
      state.error = null;
      state.entities = [];
      // state.totalCount = 0;
      state.exportData = [];
    },

    rewardsCategoriesList: (state, action) => {
      const { totalCount, entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.totalCount = totalCount;
    },
    rewardsCategoriesExport: (state, action) => {
      const { exportData } = action.payload;
      // state.listLoading = false;
      // state.error = null;
      state.exportData = exportData;
    },
    uploadImage: (state, action) => {
      const { uploadimage, imageField} = action.payload;
      state.error = null;
      state.uploadimage = uploadimage;
      state.imageField = imageField;
    },
    createRewardsCategory: (state, action) => {
      const { newRewardsCategory } = action.payload;
      state.error = null;
      state.newRewardsCategory = newRewardsCategory;
    },
    updateRewardsCategory: (state, action) => {
      const { editRewardsCategory } = action.payload;
      state.error = null;
      state.editRewardsCategory = editRewardsCategory;
    },
    deleteRewardsCategory: (state, action) => {
      const { deletedRewardsCategory } = action.payload;
      state.error = null;
      state.deletedRewardsCategory = deletedRewardsCategory;
    },
    CompanyDropdownList: (state, action) => {
      const { companyDropdownList } = action.payload;
      state.companyDropdownList = companyDropdownList;
    },
    CountryList: (state, action) => {
      const { countryList } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.countryList = countryList;
    },
  }
});
